import { render, staticRenderFns } from "./home_brigad_ajil_zar.vue?vue&type=template&id=0bae3c6b&scoped=true&"
import script from "./home_brigad_ajil_zar.vue?vue&type=script&lang=js&"
export * from "./home_brigad_ajil_zar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bae3c6b",
  null
  
)

export default component.exports